import React from 'react';


// const URL = "C:/Documents and Settings/Pirasana/Desktop/Portfolio.html";

const Portfolio = ({ onSectionChange }) => {
  const scrollToSection = (sectionId) => (e) => {
    e.preventDefault();
    if (onSectionChange) onSectionChange(sectionId);
    const section = document.getElementById(sectionId);
    if (section) {
      section.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="bg-gray-100 min-h-screen relative">
      {/* navbar */}
      <div className="fixed top-[120px] right-10 bg-gray-100 p-2 shadow-sm rounded-lg" style={{ zIndex: 2 }}>
       <nav className="flex flexnowrap justify-center space-x-6 sm:text-[15px] font-bold">
          <a href="#about-me" onClick={scrollToSection('about-me')} className="text-black hover:bg-orange-500 hover:text-white px-4 py-2">About Me</a>
          <a href="#skills" onClick={scrollToSection('skills')} className="text-black hover:bg-orange-500 hover:text-white px-4 py-2">Skills</a>
          <a href="#projects" onClick={scrollToSection('projects')} className="text-black hover:bg-orange-500 hover:text-white px-4 py-2">Projects</a>
          <a href="#contact" onClick={scrollToSection('contact')} className="text-black hover:bg-orange-500 hover:text-white px-4 py-2">Contact</a>
        </nav>
      </div>

      <div className="pt-28 px-4">
        {/* Animated text */}
        <div className="max-w-3xl mx-auto text-center">
          <p className="text-5xl font-bold text-gray-800 animate-fade-in">Pirasana Ariyam</p>
          <p className=" justify center text-lg text-gray-600 mt-7 animate-fade-in">
            Hii, Welcome to my portfolio, inspired by the Windows XP era of the early 2000s! 
            I thought it would be a fun and nostalgic way to showcase my work with a touch of 
            personality. While I continue to improve and add new features, feel free to check out 
            my resume on the desktop screen after looking at this page :)
          </p>
        </div>

  
        <section id="about-me" className="pt-28 mt-15">
          <div className="max-w-6xl mx-auto text-center">
            <h2 className="text-4xl font-bold text-gray-800">About Me</h2>
            <p className="mt-4 text-lg text-gray-600">
              I recently earned a Bachelor's degree in Computer Science and am currently
               exploring new technologies while actively seeking exciting opportunities. 
               This portfolio is part of that journey!            </p>
            <p className=" justify center text-lg text-gray-600 mt-7">
              Although my primary focus is in software development, I’ve recently developed
              a strong interest in finance, particularly personal investing, long-term planning,
              and understanding how economic systems work. And soo I’m open to tech roles in finance or 
              related sectors where I can contribute meaningfully while continuing to grow and learn.
            </p>
          </div>
        </section>


        <section id="skills" className="pt-20 mt-20">
          <div className="max-w-6xl mx-auto text-center">
            <h2 className="text-4xl font-bold text-gray-800">Skills</h2>
            <h4 className="text-xl font-semibold text-gray-700 mt-6">Programming Languages</h4>
            <div className="flex flex-wrap justify-center gap-4 mt-4">
              <img src="skills_icons/Python.png" alt="Python" className="w-16 h-16" />
              <img src="skills_icons/Java.png" alt="Java" className="w-16 h-16" />
              <img src="skills_icons/UML.png" alt="UML" className="w-16 h-16" />
              <img src="skills_icons/HTML.png" alt="HTML" className="w-16 h-16" />
              <img src="skills_icons/CSS.png" alt="CSS" className="w-16 h-16" />
              <img src="skills_icons/JavaScript.png" alt="JavaScript" className="w-16 h-16" />
              <img src="skills_icons/React.png" alt="React" className="w-16 h-16" />
              <img src="skills_icons/TypeScript.png" alt="TypeScript" className="w-16 h-16" />
              <img src="skills_icons/SQL.png" alt="SQL" className="w-16 h-16" />
            </div>

            <h4 className="text-xl font-semibold text-gray-700 mt-10">Technologies & Tools</h4>
            <div className="flex flex-wrap justify-center gap-4 mt-4">
              <img src="skills_icons/VSCode.png" alt="VSCode" className="w-16 h-16" />
              <img src="skills_icons/Git.png" alt="Git" className="w-16 h-16" />
              <img src="skills_icons/GitHub.png" alt="GitHub" className="w-16 h-16" />
              <img src="skills_icons/NodeJS.png" alt="NodeJS" className="w-16 h-16" />
              <img src="skills_icons/MongoDB.png" alt="MongoDB" className="w-16 h-16" />
              <img src="skills_icons/npm.png" alt="npm" className="w-16 h-16" />
            </div>

            <h4 className="text-xl font-semibold text-gray-700 mt-10">Proficient Languages</h4>
            <p className="mt-4 text-gray-600 text-lg">English, French, Tamoul</p>
          </div>
        </section>

   
        <section id="projects" className="pt-20 mt-20">
          <div className="max-w-6xl mx-auto text-center">
            <h2 className="text-3xl font-bold text-gray-800 text-center">Projects</h2>
            <div className='flex flex-row'> 
              <div className='max-w-screen-xl px-6 py-12 space-y-24'>
                {/*<--Project 1 -->*/}
                <div className=' flex flex-col md:flex-row md:items-center md:space-x-16'>
                  <div className="md:w-5/12 space-y-2 text-2xl text-gray-800">
                  <div className="text-2xl font-semibold text-gray-700 text-left ">
                    DyNotate :<span className="text-xl"> Dynamic Definition of Notations with Interactive AI</span>

                  </div>
                  <p className="text-base text-black-500 text-justify">DyNotate is a proof-of-concept platform that lets users dynamically create and define notations through drawing and speech/text, which an AI powered by a multi-modal language model can understand and interact with. It tackles the challenge of “dynamic grounding,” where human and AI build shared meaning for new symbols during conversation.</p>
                  <p className="text-base text-black-500 text-justify">I contributed to further developing DyNotate’s interactive tools and system architecture, enabling human gameplay and setting the stage for comparing AI’s ability to learn and use novel rule-based notations. This work combines multi-modal AI, human-computer interaction, and research on evolving symbolic communication.</p>
                  </div>
                  <div className="w-7/12 rounded-lg shadow-lg max-h-[500px] object-contain">
                  <img src='images/Dynotate.png' alt='Dynotate-app-screen'></img>
                  </div>
                </div>

                {/*<--Project 2 -->*/}
                <div className='flex flex-col md:flex-row-reverse md:items-center md:space-x-16 md:space-x-reverse'>
                  <div className="md:w-5/12 space-y-2 text-2xl text-gray-800">
                  <div className="text-2xl font-semibold text-gray-700 text-right ">HiddenTreasures <span className="text-xl">(PolyHacks 2024)</span></div>
                  
                  <p className="text-base text-black-500 text-justify">Built with a team of first-time hackathon participants for a sustainability-themed challenge, HiddenTreasures is a web app that lets users give away household items they want to throw out, helping others pick them up for free. We used Google Maps for geolocation, ReactJS for the front end, and MongoDB to store item listings and user data, encouraging reuse and sustainability. We presented to a judging panel and placed 6th in our category..</p>
                  </div>
                  <div className="w-7/12 rounded-lg shadow-lg max-h-[500px] object-contain">
                  <img src='images/PolyHacks24.png' alt='Polyhacks-website-img'></img>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default Portfolio;
